type CardProps = {
  section: LeanSection;
};

enum LeanSection {
  DOCS = 'docs',
  EXAMPLES = 'examples',
  MODEL_LIBRARY = 'model-library',
  API_REFERENCE = 'api-reference',
  BLOG = 'blog',
}

export type { CardProps };
export { LeanSection };
